import { render, staticRenderFns } from "./ImfMstShiftTeamList.vue?vue&type=template&id=270ffa13&"
import script from "./ImfMstShiftTeamList.vue?vue&type=script&lang=js&"
export * from "./ImfMstShiftTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports